// extracted by mini-css-extract-plugin
module.exports =  {"image":"WFarx9K"};